import React, { useMemo } from "react";

import DisplayPropertiesCard from "@covertree/ui/content/DisplayPropertiesCard";
import { slugify } from "@covertree/utils";
import { Box, Grid, Typography } from "@mui/material";
import { RenewalStatus } from "@covertree/agent-portal-graphql";
import { mapRenewalUwReviewToDescription } from "@utils/mapRenewalUwReviewToDescription";

import { RenewalDetailsContentProps } from "@routing/routes/Renewals/RenewalDetails/RenewalDetailsContent/ContentTabs/types";

export function Description({ renewal }: RenewalDetailsContentProps) {
  const isUWReviewRenewal = useMemo(
    () => renewal?.status === RenewalStatus.UwReview,
    [renewal?.status]
  );

  const descriptionItems: string[] = mapRenewalUwReviewToDescription(renewal);

  return (
    <Grid item xs={12}>
      <DisplayPropertiesCard
        childrenDisplayBlock={isUWReviewRenewal}
        properties={[
          {
            label: "Description",
            value: isUWReviewRenewal ? (
              <Box
                component="ul"
                sx={(theme) => ({
                  marginTop: 0,
                  marginBottom: 0,
                  marginLeft: theme.spacing(-2),
                })}>
                {descriptionItems.map((reason) => (
                  <Box key={slugify(reason!)} component="li">
                    <Typography>{reason}</Typography>
                  </Box>
                ))}
              </Box>
            ) : (
              renewal?.description || "None"
            ),
            gridSize: 12,
          },
        ]}
      />
    </Grid>
  );
}
